import store from '@/store'
import i18n from '@/libs/i18n'

export const LOCALIZATION_FALLBACKS: Record<string, Record<string, string>> = {
  delivery_fee: {
    en: 'Delivery Fee',
    ar: 'رسوم التوصيل',
  },
}

export function getRestaurant(source?: Record<string, any>) {
  const user = source || store.getters['auth/user'] || {}
  return user.restaurant || user
}

export function getLocaleCode(locale?: string) {
  return `${locale || i18n.locale || 'en'}`.substring(0, 2)
}

export function getFallbackValue(key: string, locale?: string) {
  const current = getLocaleCode(locale)
  return LOCALIZATION_FALLBACKS[key]?.[current]
    || LOCALIZATION_FALLBACKS[key]?.en
    || ''
}

function resolveLocalizations(source?: Record<string, any>) {
  const authUser = store.getters['auth/user'] || {}
  const candidates = [
    source?.localizations,
    source?.restaurant?.localizations,
    source && getRestaurant(source)?.localizations,
    authUser?.localizations,
    authUser?.restaurant?.localizations,
  ]
  return candidates.find(item => item && (Array.isArray(item) ? item.length : typeof item === 'object'))
}

export function getRestaurantLocalization(key: string, locale?: string, source?: Record<string, any>) {
  const current = getLocaleCode(locale)
  const fallback = getFallbackValue(key, current)
  const localizations = resolveLocalizations(source)

  if (!localizations) return fallback

  if (!Array.isArray(localizations)) {
    const byKey = localizations[key]
    if (byKey && typeof byKey === 'object') {
      return byKey[current] || byKey.en || fallback
    }
  }

  if (Array.isArray(localizations)) {
    const item = localizations.find((entry: any) => entry.key === key)
    const value = item?.locales?.find((entry: any) => entry.locale === current)?.value
    if (value) return value
    const english = item?.locales?.find((entry: any) => entry.locale === 'en')?.value
    if (english) return english
  }

  return fallback
}

export function getLocaleValue(item: { locales?: Array<{ locale: string; value: string }> } | null | undefined, locale?: string) {
  const current = getLocaleCode(locale)
  return item?.locales?.find(entry => entry.locale === current)?.value || ''
}
